import React, {useEffect, useState} from 'react';
import {ContentHeader} from '@components';
import Card from 'react-bootstrap/Card';
import {NavDropdown} from 'react-bootstrap';
import {useSearchParams} from 'react-router-dom';
import SurveyItem from './SurveyItem';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import {question_vn} from '../utils/question_vn';
import {Button} from 'react-bootstrap';
import * as AuthService from '../services/auth';
import {toast} from 'react-toastify';
import Modal from 'react-bootstrap/Modal';

export interface Language {
  key: string;
  icon: string;
  label: string;
}
const languages: Language[] = [
  {
    key: 'en',
    icon: 'flag-icon-us',
    label: 'English'
  },
  {
    key: 'vn',
    icon: 'flag-icon-vn',
    label: 'Tiếng Việt'
  }
];
const LanguagesDropdown = () => {
  const [currentLanguage, SetCurrentLanguage] = useState<any>({
    key: 'en',
    icon: 'flag-icon-us',
    label: 'header.language.english'
  });

  const changeLanguage = (lng: string) => {
    SetCurrentLanguage(languages.find((l) => l.key === lng));
  };

  const getCurrentLanguage = (): Language => {
    // const currentLanguage = i18n.language;
    const _currentLanguage = currentLanguage.key;
    if (_currentLanguage) {
      const language = languages.find(
        (language: Language) => language.key === _currentLanguage
      );
      return language || languages[0];
    }
    return languages[0];
  };

  return (
    <NavDropdown
      title={
        <div style={{display: 'inline-block'}}>
          <i className={`flag-icon ${getCurrentLanguage().icon}`} />
        </div>
      }
      id="collasible-nav-dropdown"
    >
      {languages.map((language) => (
        <NavDropdown.Item
          onClick={() => {
            changeLanguage(language.key);
          }}
          key={language.key}
        >
          <i className={`flag-icon ${language.icon} mr-2`} />
          <span>{language.label}</span>
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
};

export default function SurveyVn() {
  const [language, SetLanguage] = useState<any>({key: 'vn'});
  const [state, setState] = useState<any[]>([]);
  const [error, setError] = useState('');
  const [showMd, setShowMd] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [customer, setCustomer] = useState(
    searchParams.get('customerid') || '0000'
  );

  const onSubmit = async () => {
    try {
      // 請回答所有調查問題。
      // Please answer all survey questions.
      const answerAll = state.find((e) => e.valid === false) === undefined;
      console.log(answerAll);
      if (answerAll === true) {
        setError('');
        const input = {
          customer: customer,
          data: state,
          group: question_vn[0].survey_group_id
        };
        const result = await AuthService.uploadSurvey(input);
        if (result.error) throw 'timeout';
        // success
        setShowMd(true);
      } else {
        setError(
          language.key === 'en'
            ? 'Please answer all survey questions.'
            : 'Vui lòng trả lời tất cả các câu hỏi khảo sát'
        );
      }
    } catch (error) {
      //error
      toast.error('Network error, try again later.');
    }
  };

  const onChange = (
    number: number,
    id: number,
    value: string,
    checked: boolean,
    type: string
  ) => {
    // console.log(number); คือ question number 1-6
    // console.log(id); คือ choice number 0-n
    // console.log(value); คือค่าที่ตอบ
    // console.log(checked); คือสถานะ true false
    // console.log(type); คือ single multiple

    let temp = state.map((e) => {
      if (e.question_number === number && checked === true) {
        if (type === 'single') {
          return {...e, answer: [value], valid: true};
        } else {
          let arr = [...e.answer];
          arr.push(value);
          return {...e, answer: arr, valid: arr.length >= 1};
        }
      } else if (e.question_number === number && checked === false) {
        let arr = [...e.answer];
        const index = arr.indexOf(value);
        if (index > -1) {
          arr.splice(index, 1);
        }
        return {...e, answer: arr, valid: arr.length >= 1};
      } else {
        return e;
      }
    });

    // ถ้าคำตอบข้อ 3 เป็น Double A ให้ซ้อนคำถามข้อ 4
    // ถ้าคำตอบข้อ 3 เป็นอื่นๆ ให้ซ้อนคำถามข้อ 5
    if (number === 3 && value === 'Double A') {
      temp = temp.map((e) => {
        if (e.question_number === 4) {
          return {...e, show: false, valid: true};
        } else {
          return {...e, show: true};
        }
      });
    }
    if (number === 3 && value !== 'Double A') {
      temp = temp.map((e) => {
        if (e.question_number === 5) {
          return {...e, show: false, valid: true};
        } else {
          return {...e, show: true};
        }
      });
    }

    console.log(temp);
    setState(temp);
  };

  useEffect(() => {
    let temp: any[] = [];
    question_vn.map((e: any) => {
      const item = {
        question_number: e.question_number,
        question: e.question_en,
        answer: [],
        show: true,
        valid: false,
        group: e.survey_group_id
      };
      temp.push(item);
    });
    setState(temp);
  }, []);

  return (
    <div>
      <Modal
        show={showMd}
        backdrop="static"
        keyboard={false}
        onHide={() => setShowMd(false)}
      >
        <Modal.Header>{language.key === 'en' ? 'Information' : 'Thông tin'}</Modal.Header>
        <Modal.Body>{language.key === 'en' ? 'Thank you for taking the survey.' : 'Cám ơn Quý khách đã hoàn thành khảo sát!'}</Modal.Body>
        <Modal.Footer>
          <Button onClick={()=>(self.close())}>
            {language.key === 'en' ? 'Close' : 'Đóng'}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <ContentHeader title="Survey Question" /> */}
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Card className="card">
                <Card.Header>
                  <div className="row">
                    <div className="col-6 mt-2">
                      {language.key === 'en'
                        ? 'Take a quick survey'
                        : 'Hãy làm một cuộc khảo sát nhanh'}
                    </div>
                    <div className="col-6" style={{textAlign: 'end'}}>
                      {' '}
                      <BootstrapSwitchButton
                        width={160}
                        checked={language.key === 'en'}
                        onlabel="English"
                        offlabel="Tiếng Việt"
                        offstyle="success"
                        onChange={(checked) => {
                          SetLanguage((prev: any) => ({
                            ...prev,
                            key: checked === true ? 'en' : 'vn'
                          }));
                        }}
                      />
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  {question_vn.map((e, i) => (
                    <SurveyItem
                      show={state[i]}
                      key={`question-${e.question_number}`}
                      question={
                        language.key === 'en' ? e.question_en : e.question_vn
                      }
                      question_number={e.question_number}
                      question_type={e.question_type}
                      choice={language.key === 'en' ? e.choice_en : e.choice_vn}
                      onChange={onChange}
                    ></SurveyItem>
                  ))}
                </Card.Body>
                <Card.Footer>
                  <div style={{color: 'red'}}>{error}</div>
                  <Button
                    variant="success"
                    className="col-12"
                    onClick={onSubmit}
                  >
                    {language.key === 'en' ? 'Submit' : 'Nộp'}
                  </Button>
                </Card.Footer>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
